import React from "react";
import styles from "./Box.module.scss";

export interface BoxProps {
  rounded?: boolean;
  variant?: BoxVariant;
  className?: string;
  style?: React.CSSProperties;
}

export enum BoxVariant {
  primary = "primary",
  warning = "warning",
}

export const Box: React.FC<BoxProps> = ({
  className,
  rounded = true,
  variant = BoxVariant.primary,
  children,
  style,
}) => {
  const classNames = [styles.box, styles[variant]];
  if (className) classNames.push(className);
  if (rounded) classNames.push(styles.rounded);

  return (
    <div style={style} className={classNames.join(" ")}>
      {children}
    </div>
  );
};
